import imageCompression from "browser-image-compression";
import { WATI_FILE_RULES, WATI_MAX_MEDIA_BYTES } from "../qv4/constants";

const MAX_BACKEND_BYTES = 50 * 1024 * 1024;

export function canonicalMediaKind(file) {
  const mimeType = file?.type?.split(";", 1)[0]?.trim().toLowerCase();
  // The canonical backend converts browser-recorded WebM/Opus to MP3 before
  // handing it to the current provider. The legacy file picker cannot do that.
  const rule = mimeType === "audio/webm"
    ? { category: "audio", maxBytes: WATI_MAX_MEDIA_BYTES }
    : WATI_FILE_RULES[mimeType];
  if (!rule) throw new Error("This file type is not supported for WhatsApp messages.");
  if (!file.size) throw new Error("The selected file is empty.");
  if (file.size > Math.min(rule.maxBytes, MAX_BACKEND_BYTES)) throw new Error("This file exceeds the allowed size for WhatsApp messages.");
  return rule.category;
}

export async function encodeCanonicalMedia(file) {
  const kind = canonicalMediaKind(file);
  const prepared = kind === "image" && file.size > 4 * 1024 * 1024
    ? await imageCompression(file, { maxSizeMB: 4, maxWidthOrHeight: 2048, useWebWorker: true, fileType: file.type })
    : file;
  if (prepared.size > MAX_BACKEND_BYTES) throw new Error("The prepared file exceeds the upload limit.");
  const dataBase64 = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result).split(",", 2)[1] || "");
    reader.onerror = () => reject(new Error("Could not read the selected file."));
    reader.readAsDataURL(prepared);
  });
  if (!dataBase64) throw new Error("Could not read the selected file.");
  return { kind, fileName: prepared.name || file.name, mimeType: prepared.type || file.type, dataBase64 };
}
